import { render, staticRenderFns } from "./DefaultReport.vue?vue&type=template&id=9596e468&"
import script from "./DefaultReport.vue?vue&type=script&lang=js&"
export * from "./DefaultReport.vue?vue&type=script&lang=js&"
import style0 from "./DefaultReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports